import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFtlCommodityLookup extends Layout {
    sourceFtlCommodity: DataSource;
    tableCommodity: Table;
}
